import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Founder from "@/pages/Founder";
import AccountSecurity from "@/pages/AccountSecurity";
import BackButton from "@/components/BackButton";
import ViewAsToggle from "@/components/ViewAsToggle";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Tracks from "@/pages/Tracks";
import TrackDetail from "@/pages/TrackDetail";
import Forum from "@/pages/Forum";
import Certificate from "@/pages/Certificate";
import FacilitatorDashboard from "@/pages/FacilitatorDashboard";
import ParticipantDetail from "@/pages/ParticipantDetail";
import Support from "@/pages/Support";
import Fellowship from "@/pages/Fellowship";
import AdminSubscribers from "@/pages/AdminSubscribers";
import Wallet from "@/pages/Wallet";

import "@/App.css";

// Stable references — defined outside the component so they don't trigger
// re-renders on every render.
const TOAST_OPTIONS = {
  style: {
    background: "#121110",
    color: "#F7F5F0",
    border: "1px solid rgba(201,169,97,0.25)",
  },
};
const FACILITATOR_ROLES = ["facilitator", "admin"];

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" toastOptions={TOAST_OPTIONS} />
        <div className="App min-h-screen flex flex-col">
          <Navbar />
          <ViewAsToggle />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 pt-4">
            <BackButton />
          </div>
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/about" element={<About />} />
              <Route path="/founder" element={<Founder />} />
              <Route path="/fellowship" element={<Fellowship />} />
              <Route path="/support" element={<Support />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/register" element={<Register />} />

              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account/security"
                element={
                  <ProtectedRoute>
                    <AccountSecurity />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tracks"
                element={
                  <ProtectedRoute>
                    <Tracks />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tracks/:slug"
                element={
                  <ProtectedRoute>
                    <TrackDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/forum"
                element={
                  <ProtectedRoute>
                    <Forum />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/certificate"
                element={
                  <ProtectedRoute>
                    <Certificate />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/facilitator"
                element={
                  <ProtectedRoute roles={FACILITATOR_ROLES}>
                    <FacilitatorDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/facilitator/:userId"
                element={
                  <ProtectedRoute roles={FACILITATOR_ROLES}>
                    <ParticipantDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/wallet"
                element={
                  <ProtectedRoute>
                    <Wallet />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/subscribers"
                element={
                  <ProtectedRoute roles={FACILITATOR_ROLES}>
                    <AdminSubscribers />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
